<template>
  <div id="cesiumContainer" class="cesiumContainer">
    <VideoPopup :visible="showPopup" :title="selectedPoint.text"
      :type="selectedPoint.type === 'camera' ? 'video' : 'info'" :videoUrl="selectedPoint.videoUrl"
      :info="selectedPoint.info" :showDetail="selectedPoint.type === 'camera'" @close="closePopup" />
  </div>
</template>

<script>
import * as Cesium from 'cesium'
import 'cesium/Build/Cesium/Widgets/widgets.css'
import { message } from 'ant-design-vue'
import cameraIcon from '@/assets/image/camera.png'
import cameraAbnormalIcon from '@/assets/image/camera_abnormal.png'
import parkingIcon from '@/assets/image/parking.png'
import lawnIcon from '@/assets/image/lawn.png'
import manholeCoverIcon from '@/assets/image/manhole-cover.png'
import garbageIcon from '@/assets/image/garbage.png'
import coverImage from '@/assets/image/cover.jpg'
import carImage from '@/assets/image/car.jpg'
import lawn1Image from '@/assets/image/lawn1.png'
import garbageImage from '@/assets/image/garbage.jpg'
import VideoPopup from './VideoPopup.vue'
import waterIcon from '@/assets/image/water.png'

// 设置Cesium ion token（如果需要）
//Cesium.Ion.defaultAccessToken = 'your-ion-token-if-needed'

export default {
  components: {
    VideoPopup
  },
  data() {
    return {
      viewer: null,
      showPopup: false,
      selectedPoint: {
        text: '',
        type: '',
        videoUrl: '',
        info: {}
      },
      waterQualityData: [],
      labels: [
        {
          type: 'camera',
          position: [121.602431, 30.025134],
          labelHeight: 10,
          text: '监控点A',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.603431, 30.026134],
          labelHeight: 10,
          text: '监控点B',
          image: cameraAbnormalIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.602831, 30.025534],
          labelHeight: 10,
          text: '监控点C',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.602231, 30.025734],
          labelHeight: 10,
          text: '监控点D',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.603131, 30.025934],
          labelHeight: 10,
          text: '监控点E',
          image: cameraAbnormalIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.602631, 30.026134],
          labelHeight: 10,
          text: '监控点F',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.603731, 30.025834],
          labelHeight: 10,
          text: '监控点G',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.602031, 30.026034],
          labelHeight: 10,
          text: '监控点H',
          image: cameraAbnormalIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.603331, 30.025334],
          labelHeight: 10,
          text: '监控点I',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'camera',
          position: [121.602531, 30.025934],
          labelHeight: 10,
          text: '监控点J',
          image: cameraIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'parking',
          position: [121.60361649382486, 30.026083333583927],
          labelHeight: 8,
          text: '违停点A',
          image: parkingIcon,
          videoUrl: '/videos/parking-a.mp4'
        },
        {
          type: 'parking',
          position: [121.60355974402592, 30.02534017728692],
          labelHeight: 8,
          text: '违停点B',
          image: parkingIcon,
          videoUrl: '/videos/parking-b.mp4'
        },
        {
          type: 'parking',
          position: [121.60344055222396, 30.024942629837653],
          labelHeight: 8,
          text: '违停点C',
          image: parkingIcon,
          videoUrl: '/videos/parking-c.mp4'
        },
        {
          type: 'parking',
          position: [121.60155728508806, 30.0261090173326],
          labelHeight: 8,
          text: '违停点D',
          image: parkingIcon,
          videoUrl: '/videos/parking-d.mp4'
        },
        {
          type: 'parking',
          position: [121.60148323965626, 30.02561304439054],
          labelHeight: 8,
          text: '违停点E',
          image: parkingIcon,
          videoUrl: '/videos/parking-e.mp4'
        },
        {
          type: 'lawn',
          position: [121.60140242109571, 30.02446278576481],
          labelHeight: 8,
          text: '草坪维护A',
          image: lawnIcon,
          videoUrl: '/videos/lawn-a.mp4'
        },
        {
          type: 'lawn',
          position: [121.60140712322811, 30.02456050878736],
          labelHeight: 8,
          text: '草坪维护B',
          image: lawnIcon,
          videoUrl: '/videos/lawn-b.mp4'
        },
        {
          type: 'manhole-cover',
          position: [121.60188730461078, 30.02512025836394],
          labelHeight: 8,
          text: '井盖问题A',
          image: manholeCoverIcon,
          videoUrl: '/zssqf.mp4'
        },
        {
          type: 'manhole-cover',
          position: [121.60196383889456, 30.024302904287623],
          labelHeight: 8,
          text: '井盖问题B',
          image: manholeCoverIcon,
          videoUrl: '/videos/manhole-cover-b.mp4'
        },
        {
          type: 'garbage',
          position: [121.60265622551611, 30.025833696987235],
          labelHeight: 8,
          text: '垃圾堆放A',
          image: garbageIcon,
          videoUrl: '/videos/garbage-a.mp4'
        },
        {
          type: 'garbage',
          position: [121.60251092320198, 30.026029401622466],
          labelHeight: 8,
          text: '垃圾堆放B',
          image: garbageIcon,
          videoUrl: '/videos/garbage-b.mp4'
        },
        {
          type: 'garbage',
          position: [121.60163767429373, 30.025910580062003],
          labelHeight: 8,
          text: '垃圾堆放C',
          image: garbageIcon,
          videoUrl: '/videos/garbage-c.mp4'
        },
        {
          type: 'garbage',
          position: [121.60269035529751, 30.025148686278726],
          labelHeight: 8,
          text: '垃圾堆放D',
          image: garbageIcon,
          videoUrl: '/videos/garbage-d.mp4'
        },
        {
          type: 'garbage',
          position: [121.6034695419927, 30.025279913305226],
          labelHeight: 8,
          text: '垃圾堆放E',
          image: garbageIcon,
          videoUrl: '/videos/garbage-e.mp4'
        },
        {
          type: 'garbage',
          position: [121.60196885209456, 30.024747394406603],
          labelHeight: 8,
          text: '垃圾堆放F',
          image: garbageIcon,
          videoUrl: '/videos/garbage-f.mp4'
        },
        {
          type: 'water',
          name: '水质监测点A',
          position: [121.60195806089678, 30.02454035771524],
          description: "清洁水体（低营养状态）",
          pH: 7.2,
          turbidity_NTU: 2.1,
          chlorophyll_a_ugL: 0.8,
          risk_level: "低",
          color: "#7bc043" // 绿色 - 良好
        },
        {
          type: 'water',
          name: '水质监测点B',
          position: [121.60270936353521, 30.0245166040024],
          description: "轻度富营养化（藻类增殖）",
          pH: 8.5,
          turbidity_NTU: 15.3,
          chlorophyll_a_ugL: 6.4,
          risk_level: "中",
          color: "#f9a022" // 黄色 - 警告
        },
        {
          type: 'water',
          name: '水质监测点C',
          position: [121.6020551393272,30.024995331580882],
          description: "重度富营养化（藻华爆发）",
          pH: 9.1,
          turbidity_NTU: 45.7,
          chlorophyll_a_ugL: 78.2,
          risk_level: "高",
          color: "#f65c5c" // 红色 - 危险
        }
      ]
    }
  },
  async mounted() {
    // 初始化Viewer
    const viewer = this.viewer = new Cesium.Viewer('cesiumContainer', {
      animation: false,
      timeline: false,
      baseLayerPicker: false,
      homeButton: false,
      fullscreenButton: false,
      sceneMode: Cesium.SceneMode.SCENE3D,
      terrainProvider: new Cesium.createWorldTerrainAsync({
        requestWaterMask: true,   // 请求水体效果
        requestVertexNormals: true // 请求顶点法线用于光照
      }),
      creditViewport: undefined,  // 禁用版权视口
      contextOptions: {
        webgl: {
          alpha: true  // 启用透明度
        }
      }
    })

    // 移除版权信息
    viewer._cesiumWidget._creditContainer.style.display = "none"

    // 移除默认的baseLayer（可选）
    viewer.imageryLayers.remove(viewer.imageryLayers.get(0))

    viewer.scene.skyBox.show = false;
    viewer.scene.skyAtmosphere.show = false;
    viewer.scene.backgroundColor = Cesium.Color.TRANSPARENT;
    // 启用地形深度测试，避免模型被地形遮挡
    viewer.scene.globe.depthTestAgainstTerrain = true

    // 修改点击事件处理，只处理可选中的实体
    viewer.screenSpaceEventHandler.setInputAction((movement) => {
      const pickedObject = viewer.scene.pick(movement.position);
      if (Cesium.defined(pickedObject) && pickedObject.id && pickedObject.id.selectable !== false) {
        this.openPopup(pickedObject.id);
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    // 等待模型加载完成后添加标注
    Cesium.Cesium3DTileset.fromUrl('/mapdata/3dtiles/ymf/tileset.json', {
      skipLevelOfDetail: true,
      baseScreenSpaceError: 1024,
      skipScreenSpaceErrorFactor: 16,
      skipLevels: 1,
      immediatelyLoadDesiredLevelOfDetail: false,
      loadSiblings: false,
      cullWithChildrenBounds: true,
      preferLeaves: true,
      maximumMemoryUsage: 1024
    }).then(tileset => {
      viewer.scene.primitives.add(tileset)

      // 调整模型位置
      var heightOffset = 10.0  // 调整这个值可以改变整体高度，负值会降低
      var boundingSphere = tileset.boundingSphere
      var cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
      var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0)
      var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, heightOffset)
      var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
      tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)

      // 设置相机视角
      const heading = -Math.PI / 8
      const pitch = -Math.PI / 4
      const range = tileset.boundingSphere.radius * 1
      viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(
        heading,
        pitch,
        range
      )).then(() => {
        // 等待相机就位后添加标注
        setTimeout(() => {
          // 获取模型中心点的高度作为基准
          const centerHeight = cartographic.height;
          const baseHeight = centerHeight; // 使用模型中心点的高度作为基准高度

          // 添加标注点和连接线
          this.labels.forEach(label => {
            // 创建地面点位置
            const actualGroundPosition = Cesium.Cartesian3.fromDegrees(
              label.position[0],
              label.position[1],
              baseHeight // 使用基准高度
            );

            // 创建标签位置（在地面点上方）
            const labelPosition = Cesium.Cartesian3.fromDegrees(
              label.position[0],
              label.position[1],
              baseHeight + (label.labelHeight || 10) // 在基准高度上增加标签高度
            );

            // 根据类型设置不同的样式
            let pointColor, lineColor, billboardImage, billboardScale;
            
            if (label.name && (label.name.includes('水质监测点'))) {
              // 水质监测点样式
              pointColor = Cesium.Color.fromCssColorString(label.color);
              lineColor = Cesium.Color.fromCssColorString(label.color);
              billboardImage = waterIcon;
              billboardScale = 0.8;
            } else {
              // 其他标注点样式
              pointColor = label.type === 'parking' ?
                Cesium.Color.fromCssColorString('#FF6B6B') : // 泊车问题点使用红色
                Cesium.Color.fromCssColorString('#9aeeff');  // 摄像头点使用青色

              lineColor = label.type === 'parking' ?
                Cesium.Color.fromCssColorString('#FF6B6B') :
                Cesium.Color.CYAN;
                
              billboardImage = label.image;
              billboardScale = label.type === 'parking' ? 0.8 : 0.8;
            }

            // 添加地面到标签的连接线
            const lineEntity = viewer.entities.add({
              polyline: {
                positions: [actualGroundPosition, labelPosition],
                width: 2,
                material: new Cesium.PolylineDashMaterialProperty({
                  color: lineColor,
                  dashLength: 8.0
                })
              },
              // 设置连接线不可选中
              selectable: false
            });

            // 确定实体类型
            const entityType = label.name && label.name.includes('水质监测点') ? 'water' : label.type;
            
            // 添加标签图标
            const labelEntity = viewer.entities.add({
              type: entityType,
              position: labelPosition,
              text: label.name || label.text,
              videoUrl: label.videoUrl || '',
              // 确保水质监测点的详细信息可以被访问
              info: entityType === 'water' ? {
                name: label.name,
                pH: label.pH,
                turbidity_NTU: label.turbidity_NTU,
                chlorophyll_a_ugL: label.chlorophyll_a_ugL,
                risk_level: label.risk_level,
                description: label.description,
                color: label.color
              } : undefined,
              billboard: {
                image: billboardImage,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                scale: billboardScale,
                width: 48,
                height: 48,
                color: label.name && label.name.includes('水质监测点') ? 
                  Cesium.Color.fromCssColorString(label.color) : Cesium.Color.WHITE,
                disableDepthTestDistance: Number.POSITIVE_INFINITY
              },
              label: {
                text: label.name || label.text,
                font: label.type === 'parking' ? '14px sans-serif' : '16px sans-serif',
                fillColor: label.name && label.name.includes('水质监测点') ? 
                  Cesium.Color.fromCssColorString(label.color) : 
                  (label.type === 'parking' ? Cesium.Color.fromCssColorString('#FF6B6B') : Cesium.Color.WHITE),
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                pixelOffset: new Cesium.Cartesian2(0, -36),
                disableDepthTestDistance: Number.POSITIVE_INFINITY
              }
            });

            // 添加地面点
            const pointEntity = viewer.entities.add({
              position: actualGroundPosition,
              point: {
                pixelSize: label.type === 'parking' ? 8 : 10,
                color: pointColor,
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 2,
                disableDepthTestDistance: Number.POSITIVE_INFINITY
              },
              // 设置地面点不可选中
              selectable: false
            });

            console.log('Added label at:', {
              longitude: label.position[0],
              latitude: label.position[1],
              baseHeight: baseHeight,
              labelHeight: baseHeight + (label.labelHeight || 10)
            });
          });
        }, 1000);
      });
    })

    let startHeight = 30;
    let amplitude = 20; // 浮动范围
    let frequency = 20; // 浮动速度
    let lon = 121.602431;
    let lat = 30.025134;
    // 用CallbackProperty动态返回位置，Cesium每帧都会调用
    let positionProperty = new Cesium.CallbackProperty(function (time, result) {
      // time是Cesium时间类型，这里用秒数计算
      let seconds = Cesium.JulianDate.secondsDifference(time, Cesium.JulianDate.fromDate(new Date(0)));
      let newHeight = startHeight + amplitude * Math.sin(frequency * seconds);
      return Cesium.Cartesian3.fromDegrees(lon, lat, newHeight, Cesium.Ellipsoid.WGS84, result);
    }, false);

    // 使用正确的事件总线方式监听水质数据
    this.$emitter.on('water-data-ready', (waterData) => {
      this.waterQualityData = waterData;
    });
  },

  beforeUnmount() {
    // 移除事件监听
    this.$emitter.off('water-data-ready');

    // 清除Cesium资源
    if (this.viewer) {
      this.viewer.destroy();
    }
  },

  methods: {
    getPointInfo(type, text) {
      const now = new Date()
      const timeStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
      
      switch (type) {
        case 'water':
          // 查找对应的水质监测点数据
          const waterPoint = this.labels.find(point => point.name === text);
          if (waterPoint) {
            return {
              location: waterPoint.name,
              time: timeStr,
              status: waterPoint.risk_level === '低' ? '良好' : 
                     waterPoint.risk_level === '中' ? '警告' : '危险',
              description: waterPoint.description,
              details: [
                { label: 'pH值', value: waterPoint.pH + ' pH' },
                { label: '浊度', value: waterPoint.turbidity_NTU + ' NTU' },
                { label: '叶绿素a', value: waterPoint.chlorophyll_a_ugL + ' μg/L' },
                { label: '风险等级', value: waterPoint.risk_level }
              ]
            }
          }
          return {};
        case 'parking':
          return {
            location: '停车场区域A',
            time: timeStr,
            status: '待处理',
            description: '发现违规停车行为，车辆占用消防通道。',
            imageUrl: carImage
          }
        case 'lawn':
          return {
            location: '绿化区域',
            time: timeStr,
            status: '待维护',
            description: '草坪需要修剪和养护，部分区域杂草丛生。',
            imageUrl: lawn1Image
          }
        case 'manhole-cover':
          return {
            location: '道路区域',
            time: timeStr,
            status: '需维修',
            description: '井盖破损，存在安全隐患，需要及时更换。',
            imageUrl: coverImage
          }
        case 'garbage':
          return {
            location: '公共区域',
            time: timeStr,
            status: '待清理',
            description: '垃圾未及时清理，影响环境卫生。',
            imageUrl: garbageImage
          }
        default:
          return {}
      }
    },

    openPopup(entity) {
      // 检查是否是故障摄像头
      if (entity.type === 'camera' && entity._billboard._image._value === cameraAbnormalIcon) {
        message.error({
          content: `${entity.text}故障中，暂时无法查看视频`,
          duration: 3
        });
        return;
      }

      this.selectedPoint = {
        text: entity.text || '',
        type: entity.type || '',
        videoUrl: entity.videoUrl || '',
        info: this.getPointInfo(entity.type, entity.text)
      }
      this.showPopup = true
    },

    closePopup() {
      this.showPopup = false
    }
  }
}
</script>

<style scoped>
/* 修复可能的小部件样式问题 */
.cesium-viewer-toolbar,
.cesium-viewer-animationContainer,
.cesium-viewer-timelineContainer {
  display: none !important;
}

/* 隐藏Cesium水印和版权信息 */
.cesium-widget-credits,
.cesium-credit-lightbox,
.cesium-credit-expand-link {
  display: none !important;
}

.cesiumContainer {
  width: 100%;
  height: 100%;
  background-color: #171e21b3;
  position: absolute
}
</style>